// YourNest VC Fund Mock Data

export const stats = [
  { value: "41,000+", label: "Startups Analysed" },
  { value: "₹6,000 Mn+", label: "Raised Externally by Portfolio" },
  { value: "6,500+", label: "New Jobs Created" },
  { value: "400+", label: "Patents Filed/Granted" }
];

export const partners = [
  {
    id: 1,
    name: "Sunil K Goyal",
    role: "Managing Director and Fund Manager",
    image: "https://yournest.in/wp-content/uploads/2021/06/SKG.jpg",
    linkedin: "https://www.linkedin.com/in/sunilkgoyal/"
  },
  {
    id: 2,
    name: "Girish Shivani",
    role: "Executive Director and Fund Manager",
    image: "https://yournest.in/wp-content/uploads/2021/06/Girish-Shivani.jpg",
    linkedin: "https://www.linkedin.com/in/girishshivani/"
  },
  {
    id: 3,
    name: "Sanjay Pande",
    role: "Director and Fund Manager",
    image: "https://yournest.in/wp-content/uploads/2021/06/Sanjay-Pande-1.jpg",
    linkedin: "https://www.linkedin.com/in/sanjaypande/"
  },
  {
    id: 4,
    name: "Dr. Vivek Mansingh",
    role: "General Partner",
    image: "https://yournest.in/wp-content/uploads/2021/06/Vivek-Mansingh.jpg",
    linkedin: "https://www.linkedin.com/in/vivekmansingh/"
  }
];

export const venturePartners = [
  {
    id: 5,
    name: "Venkat S. Raju",
    role: "Venture Partner",
    image: "https://yournest.in/wp-content/uploads/2021/06/venkat.jpg"
  },
  {
    id: 6,
    name: "Mohit Hira",
    role: "Venture Partner",
    image: "https://yournest.in/wp-content/uploads/2021/06/Mohit-Hira.jpg"
  },
  {
    id: 7,
    name: "Ranjeet Shetye",
    role: "Venture Partner",
    image: "https://yournest.in/wp-content/uploads/2021/06/Ranjeet-Shetye.jpg"
  },
  {
    id: 8,
    name: "Ketan Krishna",
    role: "Venture Partner",
    image: "https://yournest.in/wp-content/uploads/2021/07/Ketan-Krishna.jpg"
  }
];

export const portfolioFund3 = [
  {
    id: 1,
    name: "QpiAI",
    sector: "Quantum Computing",
    description: "Building hardware and software for quantum computing with a 25 qubit quantum computer.",
    website: "https://qpiai.tech/",
    logo: "https://yournest.in/wp-content/uploads/2024/06/QpiAi-logo-200x200-1.jpg"
  },
  {
    id: 2,
    name: "EtherealX",
    sector: "SpaceTech",
    description: "Building the world's first fully-reusable medium-lift launch vehicle with 72-hour turnaround.",
    website: "https://www.etherealx.space/",
    logo: "https://yournest.in/wp-content/uploads/2024/08/Etherealx-logo-500x500.png"
  },
  {
    id: 3,
    name: "Exponent Energy",
    sector: "Energy/EV",
    description: "Providing 15-minute rapid charge EV battery packs with 3,000-cycle life warranty.",
    website: "https://exponent.energy/",
    logo: "https://yournest.in/wp-content/uploads/2022/07/Exponent-Logo-200x200-1.jpg"
  },
  {
    id: 4,
    name: "Miko",
    sector: "Robotics/AI",
    description: "Companion robot engaging kids in 140+ countries with emotionally intelligent AI.",
    website: "https://miko.ai/",
    logo: "https://yournest.in/wp-content/uploads/2021/07/Miko-logo-200x200-1.jpg"
  },
  {
    id: 5,
    name: "Dozee",
    sector: "HealthTech",
    description: "India's first contactless remote health monitoring startup tracking key vitals.",
    website: "https://www.dozee.health/",
    logo: "https://yournest.in/wp-content/uploads/2021/06/Dozee-logo-200x200-1.jpg"
  },
  {
    id: 6,
    name: "WIOM",
    sector: "Telecom",
    description: "India's first and largest PDOA providing affordable internet from ₹5/day.",
    website: "https://wiom.in/",
    logo: "https://yournest.in/wp-content/uploads/2022/04/Wiom-new-logo-200x200-1.jpg"
  },
  {
    id: 7,
    name: "Datoms",
    sector: "IoT/Industry 4.0",
    description: "Hardware agnostic platform enabling Equipment as a Service for asset-heavy industries.",
    website: "https://datoms.io/",
    logo: "https://yournest.in/wp-content/uploads/2023/11/Datoms-Logo-200x200-1.jpg"
  },
  {
    id: 8,
    name: "Map My Crop",
    sector: "AgriTech",
    description: "AI/ML-powered satellite imagery platform optimizing crop yields and soil health.",
    website: "https://mapmycrop.com/",
    logo: "https://yournest.in/wp-content/uploads/2025/02/Map-My-Crop-logo.jpeg"
  }
];

export const portfolioFund2 = [
  {
    id: 9,
    name: "CRON AI",
    sector: "Autonomous Systems",
    description: "Adaptive 3D data perception platform for smart spaces and intelligent transport.",
    website: "https://www.cronai.ai/",
    logo: "https://yournest.in/wp-content/uploads/2021/06/Cron-logo-200x200-1.jpg"
  },
  {
    id: 10,
    name: "Practically",
    sector: "EdTech",
    description: "Immersive K12 learning using AI/VR/AR/MR creating EdTech metaverse.",
    website: "https://www.practically.com/",
    logo: "https://yournest.in/wp-content/uploads/2021/06/Practically-logo-200x200-1.jpg"
  },
  {
    id: 11,
    name: "ION Energy",
    sector: "CleanTech",
    description: "Battery management and intelligence systems for EVs and Data Centres.",
    website: "https://www.ionenergy.co/",
    logo: "https://yournest.in/wp-content/uploads/2021/06/ION-logo-200x200-1.jpg"
  },
  {
    id: 12,
    name: "Uptime AI",
    sector: "Industrial AI",
    description: "AI-based industrial plant monitoring with predictive maintenance.",
    website: "https://www.uptimeai.com/",
    logo: "https://yournest.in/wp-content/uploads/2021/06/Uptime-logo-200x200-1.jpg"
  }
];

export const portfolioFund1 = [
  {
    id: 13,
    name: "Uniphore",
    sector: "Conversational AI",
    description: "Global leader in voice/speech recognition and NLP. Unicorn valued at $2.5B.",
    website: "https://www.uniphore.com/",
    logo: "https://yournest.in/wp-content/uploads/2021/06/Uniphore-logo-200x200-1.jpg",
    isExit: true
  },
  {
    id: 14,
    name: "Twid",
    sector: "FinTech",
    description: "World's first rewards payment network enabling Pay with Rewards.",
    website: "https://twidpay.com/",
    logo: "https://yournest.in/wp-content/uploads/2021/07/Twid-logo-200x200-1.jpg"
  },
  {
    id: 15,
    name: "Opkey",
    sector: "Enterprise Software",
    description: "Codeless continuous testing automation platform powered by Generative AI.",
    website: "https://www.opkey.com/",
    logo: "https://yournest.in/wp-content/uploads/2021/07/Opkey-logo-200x200-1.jpg"
  },
  {
    id: 16,
    name: "Arya.ai",
    sector: "AI/FinTech",
    description: "AI tech stack for automation in financial institutions.",
    website: "https://arya.ai/",
    logo: "https://yournest.in/wp-content/uploads/2021/06/arya-logo-200x200-1.jpg"
  }
];

export const sectors = [
  { name: "AI & Machine Learning", icon: "Brain" },
  { name: "SpaceTech", icon: "Rocket" },
  { name: "Quantum Computing", icon: "Atom" },
  { name: "Energy & CleanTech", icon: "Zap" },
  { name: "IoT & Industry 4.0", icon: "Cpu" },
  { name: "Robotics", icon: "Bot" },
  { name: "HealthTech", icon: "HeartPulse" },
  { name: "FinTech", icon: "Landmark" }
];

export const investors = [
  { name: "NIIF", description: "National Investment & Infrastructure Fund (Anchor - Fund III)" },
  { name: "MaxLife Insurance", description: "Fund III Investor" },
  { name: "SIDBI", description: "Investor in all three funds" },
  { name: "MeitY EDF", description: "Electronic Development Fund (Fund II)" },
  { name: "Northgate Capital", description: "Fund I Investor" },
  { name: "IIFL Seed Venture", description: "Fund I Investor" }
];

export const news = [
  {
    id: 1,
    title: "QpiAI raises $32 million from Avataar, NQM to build Quantum Computers",
    date: "July 16, 2025",
    source: "Business Standard",
    link: "https://yournest.in/qpiai-raises-32-million-from-avataar-nqm-to-build-quantum-computers/"
  },
  {
    id: 2,
    title: "CredRight raises $10M in Series B funding from Abler Nordic",
    date: "August 15, 2025",
    source: "YourStory",
    link: "https://yournest.in/credright-raises-10m-in-series-b-funding-from-abler-nordic-michael-susan-dell-foundation/"
  },
  {
    id: 3,
    title: "YourNest VC On Finding The Patient Capital Fuel That Indian DeepTech Needs",
    date: "July 03, 2025",
    source: "INC42",
    link: "https://yournest.in/yournest-vc-on-finding-the-patient-capital-fuel-that-indian-deeptech-needs/"
  }
];

export const fundInfo = {
  totalAUM: "$53 Mn",
  portfolioValue: "~$1.2 Bn",
  fund3Investment: "$33 Mn",
  fund3Focus: "Indian DeepTech",
  fund2Size: "$30 Mn",
  fund1Size: "$14 Mn",
  founded: "2012"
};

export const nurtureCapitalPillars = [
  {
    title: "Mentorship & Coaching",
    description: "Our partners mentor and coach entrepreneurs through every phase of growth.",
    icon: "GraduationCap"
  },
  {
    title: "Strategic Advisory",
    description: "Expert guidance in strategy, compliance, legal, HR, and talent sourcing.",
    icon: "Compass"
  },
  {
    title: "Network Access",
    description: "Access to corporates and individuals who can multiply advantage for investees.",
    icon: "Network"
  },
  {
    title: "Empathy-Driven",
    description: "Empathy at the core of our DNA, empowering stakeholders with understanding.",
    icon: "Heart"
  }
];

export const founderFAQs = [
  {
    question: "What stage does YourNest invest in?",
    answer: "We focus on early-stage Indian technology startups that have translated an idea into a product and have customer validation. We typically invest at Pre-Series A and Series A stages."
  },
  {
    question: "What sectors do you focus on?",
    answer: "Our Fund III focuses on Indian DeepTech including AI, SpaceTech, Quantum Computing, Energy Management, IoT, Robotics, Dev Tools, and Edge Cloud technologies."
  },
  {
    question: "What is your typical cheque size?",
    answer: "Our initial investments typically range from $500K to $2M, with follow-on capacity for subsequent rounds."
  },
  {
    question: "What does YourNest NOT invest in?",
    answer: "We generally do not invest in pure consumer internet plays, marketplace businesses without deep tech differentiation, or businesses without clear paths to profitability."
  },
  {
    question: "What makes a strong YourNest-fit company?",
    answer: "We look for 'Challengineers' - committed entrepreneurs who question the status quo to create disruptive products. Strong tech IP, customer validation, and scalable business models are key."
  },
  {
    question: "What is the typical decision timeline?",
    answer: "From first meeting to term sheet, our process typically takes 4-6 weeks, followed by due diligence and closing."
  }
];
